import { compose, isEmpty } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './GroupAvatarQueue.style';

import { small } from './setting/avatarVariants';

import { getUserAvatar } from '@e180/domain/lib/user/util';
import DefaultUserAvatar from 'src/shared/components/domain/user/avatar/DefaultUserAvatar';
import Avatar from 'src/shared/ui/component/image/Avatar';
import type { User } from '@e180/domain/lib/user/type';

type Props = {
  participants: Array<User>,
};

const useStyles = createUseStyles(styles);

const BraindateCardGroupAvatarQueue = ({ participants }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const props = {
    variant: small,
    alt: '',
  };

  const avatarsElts = participants.map((participant, idx) => {
    const avatar = getUserAvatar(participant);

    if (avatar && !isEmpty(avatar)) {
      return (
        <Avatar {...props} src={avatar} key={idx} layoutClass={classes.root} />
      );
    }
    return (
      <DefaultUserAvatar
        {...props}
        user={participant}
        key={idx}
        layoutClass={classes.root}
      />
    );
  });

  return <span className={classes.avatars}>{avatarsElts}</span>;
};

export default compose(React.memo)(BraindateCardGroupAvatarQueue);
